import type { NormalizedFormValues } from '#src/app/pages/petitionDetails/shared/types';

const REDACTED = '[Redacted]';

/**
 * Exhaustive on purpose: adding a field to `NormalizedFormValues` is a compile error until someone
 * decides whether it is sensitive.
 */
const SENSITIVE_FIELDS: Record<keyof NormalizedFormValues, boolean> = {
	firstName: true,
	lastName: true,
	email: true,
	address: true,
	city: true,
	stateCode: true,
	countryCode: true,
	postalCode: true,
	phoneNumber: true,
	reasonForSigning: true,
	recaptchaResponse: true,
	userId: true,
	marketingCommsConsent: false,
	smsCommsConsent: false,
	whatsappCommsConsent: false,
	promotionAlgorithm: false,
	public: false,
	shareInfoWithOrganization: false,
};

export function redactSensitiveSignatureData(formData: NormalizedFormValues): NormalizedFormValues {
	const shallowClone: Record<string, unknown> = { ...formData };

	for (const [key, isSensitive] of Object.entries(SENSITIVE_FIELDS)) {
		if (isSensitive && shallowClone[key] && typeof shallowClone[key] === 'string') {
			shallowClone[key] = REDACTED;
		}
	}

	return shallowClone as NormalizedFormValues;
}
